(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-info-hv"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.brands-info .swiper-container', {
      spaceBetween: 0,
      slidesPerView: "auto",
      loop: true,
      freeMode: true,
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     }
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-announcement"] && !Shopify.designMode) return;
  try {
    
  /* Message rotation. Stops on hover or when focus lands inside, and does not
     auto-start if the visitor requested reduced motion: a bar that changes
     text every few seconds is exactly what bothers them in that case -- the
     arrows keep working. */
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsAnnReady) return;
      root.dataset.hsAnnReady = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ann-item]'));
      if (items.length < 2) return;

      var i = 0;
      var timer = null;

      function show(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (el, k) {
          if (k === i) { el.setAttribute('data-active', ''); } else { el.removeAttribute('data-active'); }
        });
      }

      function start() {
        if (REDUCE || timer) return;
        var every = parseInt(root.getAttribute('data-interval'), 10) || 6000;
        timer = setInterval(function () { show(i + 1); }, every);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var prev = root.querySelector('[data-hs-ann-prev]');
      var next = root.querySelector('[data-hs-ann-next]');
      if (prev) prev.addEventListener('click', function () { stop(); show(i - 1); });
      if (next) next.addEventListener('click', function () { stop(); show(i + 1); });

      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      start();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-announcement"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-footer"] && !Shopify.designMode) return;
  try {
    
  /* Footer accordion, only below 1024 (above that the CSS leaves everything
     open). Unlike the "One fabric" one, here several can be open at once:
     they are independent link lists, not steps of the same story. */
  (function () {
    function init(root) {
      if (root.dataset.hsFtReady) return;
      root.dataset.hsFtReady = '1';

      root.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 1024px)').matches) return;
        var btn = e.target.closest && e.target.closest('[data-hs-ft-toggle]');
        if (!btn) return;
        var group = btn.closest('[data-hs-ft-group]');
        var open = group.hasAttribute('data-open');
        if (open) { group.removeAttribute('data-open'); } else { group.setAttribute('data-open', ''); }
        btn.setAttribute('aria-expanded', String(!open));
      });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-footer"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-beforeafter-ages"] && !Shopify.designMode) return;
  try {
    
  /* The size filter does not hide cases: it reduces the list the arrows
     advance over, so the counter says "1 of 6" when filtering by a group. A
     chip with no cases arrives disabled straight from Liquid. */
  (function () {
    function init(root) {
      if (root.dataset.hsBaReady) return;
      root.dataset.hsBaReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-slide]'));
      if (!slides.length) return;

      var shots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-shot]'));
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-filter]'));
      var count = root.querySelector('[data-hs-ba-count]');
      /* There are two sets of arrows -- the panel's and the photo row's --
         and only one shows at a time. Both are wired up: which one is
         visible is decided by the CSS, not the JS. */
      var prev = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-prev]'));
      var next = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-next]'));
      var ofWord = root.getAttribute('data-of') || 'of';

      var media = root.querySelector('.hs-ba__media');
      var progress = root.querySelector('[data-hs-ba-progress]');
      var wide = window.matchMedia('(min-width: 1024px)');

      /* Two modes with the same list: on desktop one photo shows and the
         arrows lead; on phone every filtered one sits on a track and
         whichever ends up centered while dragging leads. */
      function isRail() { return !wide.matches; }

      var pool = slides.slice();
      var i = 0;
      var syncing = false;

      function idOf(slide) { return slide.getAttribute('data-hs-ba-slide'); }
      function shotOf(slide) {
        var id = idOf(slide);
        for (var k = 0; k < shots.length; k++) {
          if (shots[k].getAttribute('data-hs-ba-shot') === id) return shots[k];
        }
        return null;
      }

      function paint(recenter) {
        var current = pool[i];
        if (!current) return;
        slides.forEach(function (s) { s.hidden = s !== current; });

        if (isRail()) {
          /* On the track every filtered one shows, not just the current
             one. */
          shots.forEach(function (n) { n.hidden = true; });
          pool.forEach(function (s) {
            var sh = shotOf(s);
            if (sh) sh.hidden = false;
          });
          if (recenter && media) {
            var target = shotOf(current);
            if (target) {
              syncing = true;
              media.scrollLeft = target.offsetLeft - media.offsetLeft;
              /* Smooth scrolling fires events; they are ignored until it
                 settles. */
              setTimeout(function () { syncing = false; }, 120);
            }
          }
        } else {
          var id = idOf(current);
          shots.forEach(function (n) { n.hidden = n.getAttribute('data-hs-ba-shot') !== id; });
        }

        if (count) count.textContent = (i + 1) + ' ' + ofWord + ' ' + pool.length;

        /* The thumb takes up the fraction it's owed and travels across
           whatever is left of the track: on the first it sits flush left
           and on the last, flush right. Width and position are percentages
           of the same track, so there's no need to know how many pixels it
           measures. */
        if (progress) {
          var n = pool.length;
          var wPct = n ? Math.max(100 / n, 8) : 100;
          var ratio = n > 1 ? i / (n - 1) : 0;
          progress.style.width = wPct + '%';
          progress.style.left = ((100 - wPct) * ratio) + '%';
        }

        /* The ends are ends: it does not wrap around. The arrow that no
           longer leads anywhere gets disabled, which is what the
           stylesheet has been accounting for from the start with 35%
           opacity. */
        prev.forEach(function (btn) { btn.disabled = i <= 0; });
        next.forEach(function (btn) { btn.disabled = i >= pool.length - 1; });
      }

      /* While dragging, the text card follows whichever photo ends up most
         centered. */
      if (media) {
        media.addEventListener('scroll', function () {
          if (!isRail() || syncing) return;
          var mid = media.scrollLeft + media.clientWidth / 2;
          var best = 0;
          var bestD = Infinity;
          pool.forEach(function (s, k) {
            var sh = shotOf(s);
            if (!sh || sh.hidden) return;
            var c = sh.offsetLeft - media.offsetLeft + sh.offsetWidth / 2;
            var dd = Math.abs(c - mid);
            if (dd < bestD) { bestD = dd; best = k; }
          });
          if (best !== i) { i = best; paint(false); }
        }, { passive: true });
      }

      wide.addEventListener('change', function () { paint(true); });

      function filter(age) {
        var picked = age ? slides.filter(function (s) { return s.getAttribute('data-age') === age; }) : slides.slice();
        if (!picked.length) return;
        pool = picked;
        i = 0;
        paint(true);
      }

      filters.forEach(function (btn, k) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          filters.forEach(function (o) { o.setAttribute('aria-pressed', String(o === btn)); });
          filter(btn.getAttribute('data-hs-ba-filter'));
        });
        btn.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          filters[(k + d + filters.length) % filters.length].focus();
        });
      });

      function step(d) {
        return function () {
          var to = i + d;
          if (to < 0 || to > pool.length - 1) return;
          i = to;
          paint(true);
        };
      }
      prev.forEach(function (btn) { btn.addEventListener('click', step(-1)); });
      next.forEach(function (btn) { btn.addEventListener('click', step(1)); });
      paint(true);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-beforeafter-ages"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-beforeafter"] && !Shopify.designMode) return;
  try {
    
  /* The size filter does not hide cases: it reduces the list the arrows
     advance over, so the counter says "1 of 7" when filtering by a band. A
     chip with no cases arrives disabled straight from Liquid. */
  (function () {
    function init(root) {
      if (root.dataset.hsBaReady) return;
      root.dataset.hsBaReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-slide]'));
      if (!slides.length) return;

      var shots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-shot]'));
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-filter]'));
      var count = root.querySelector('[data-hs-ba-count]');
      /* There are two sets of arrows -- the panel's and the photo row's --
         and only one shows at a time. Both are wired up: which one is
         visible is decided by the CSS, not the JS. */
      var prev = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-prev]'));
      var next = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-next]'));
      var ofWord = root.getAttribute('data-of') || 'of';

      var media = root.querySelector('.hs-ba__media');
      var progress = root.querySelector('[data-hs-ba-progress]');
      var wide = window.matchMedia('(min-width: 1024px)');

      /* Two modes with the same list: on desktop one photo shows and the
         arrows lead; on phone every filtered one sits on a track and
         whichever ends up centered while dragging leads. */
      function isRail() { return !wide.matches; }

      var pool = slides.slice();
      var i = 0;
      var syncing = false;

      function idOf(slide) { return slide.getAttribute('data-hs-ba-slide'); }
      function shotOf(slide) {
        var id = idOf(slide);
        for (var k = 0; k < shots.length; k++) {
          if (shots[k].getAttribute('data-hs-ba-shot') === id) return shots[k];
        }
        return null;
      }

      function paint(recenter) {
        var current = pool[i];
        if (!current) return;
        slides.forEach(function (s) { s.hidden = s !== current; });

        if (isRail()) {
          /* On the track every filtered one shows, not just the current
             one. */
          shots.forEach(function (n) { n.hidden = true; });
          pool.forEach(function (s) {
            var sh = shotOf(s);
            if (sh) sh.hidden = false;
          });
          if (recenter && media) {
            var target = shotOf(current);
            if (target) {
              syncing = true;
              media.scrollLeft = target.offsetLeft - media.offsetLeft;
              /* Smooth scrolling fires events; they are ignored until it
                 settles. */
              setTimeout(function () { syncing = false; }, 120);
            }
          }
        } else {
          var id = idOf(current);
          shots.forEach(function (n) { n.hidden = n.getAttribute('data-hs-ba-shot') !== id; });
        }

        if (count) count.textContent = (i + 1) + ' ' + ofWord + ' ' + pool.length;

        /* The thumb takes up the fraction it's owed and travels across
           whatever is left of the track: on the first it sits flush left
           and on the last, flush right. Width and position are percentages
           of the same track, so there's no need to know how many pixels it
           measures. */
        if (progress) {
          var n = pool.length;
          var wPct = n ? Math.max(100 / n, 8) : 100;
          var ratio = n > 1 ? i / (n - 1) : 0;
          progress.style.width = wPct + '%';
          progress.style.left = ((100 - wPct) * ratio) + '%';
        }

        /* The ends are ends: it does not wrap around. The arrow that no
           longer leads anywhere gets disabled, which is what the
           stylesheet has been accounting for from the start with 35%
           opacity. */
        prev.forEach(function (btn) { btn.disabled = i <= 0; });
        next.forEach(function (btn) { btn.disabled = i >= pool.length - 1; });
      }

      /* While dragging, the text card follows whichever photo ends up most
         centered. */
      if (media) {
        media.addEventListener('scroll', function () {
          if (!isRail() || syncing) return;
          var mid = media.scrollLeft + media.clientWidth / 2;
          var best = 0;
          var bestD = Infinity;
          pool.forEach(function (s, k) {
            var sh = shotOf(s);
            if (!sh || sh.hidden) return;
            var c = sh.offsetLeft - media.offsetLeft + sh.offsetWidth / 2;
            var dd = Math.abs(c - mid);
            if (dd < bestD) { bestD = dd; best = k; }
          });
          if (best !== i) { i = best; paint(false); }
        }, { passive: true });
      }

      wide.addEventListener('change', function () { paint(true); });

      function filter(band) {
        var picked = band ? slides.filter(function (s) { return s.getAttribute('data-band') === band; }) : slides.slice();
        if (!picked.length) return;
        pool = picked;
        i = 0;
        paint(true);
      }

      filters.forEach(function (btn, k) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          filters.forEach(function (o) { o.setAttribute('aria-pressed', String(o === btn)); });
          filter(btn.getAttribute('data-hs-ba-filter'));
        });
        btn.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          filters[(k + d + filters.length) % filters.length].focus();
        });
      });

      function step(d) {
        return function () {
          var to = i + d;
          if (to < 0 || to > pool.length - 1) return;
          i = to;
          paint(true);
        };
      }
      prev.forEach(function (btn) { btn.addEventListener('click', step(-1)); });
      next.forEach(function (btn) { btn.addEventListener('click', step(1)); });
      paint(true);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-beforeafter"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-findfit"] && !Shopify.designMode) return;
  try {
    
  /* Size selector as a real radiogroup: a single tab stop for the group and
     the arrow keys move the selection, which is what someone navigating
     with a keyboard or screen reader expects.

     All the state lives in each button's data-*, so whatever the client
     edits in the editor is what shows, without duplicating the table in
     JS. */
  (function () {
    function init(root) {
      if (root.dataset.hsFitReady) return;
      root.dataset.hsFitReady = '1';

      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-hs-fit-size]'));
      if (!buttons.length) return;

      var photos = Array.prototype.slice.call(root.querySelectorAll('[data-hs-fit-photo]'));
      var tag = root.querySelector('[data-hs-fit-tag]');
      var out = {
        waist: root.querySelector('[data-hs-fit-waist]'),
        hips: root.querySelector('[data-hs-fit-hips]'),
        bust: root.querySelector('[data-hs-fit-bust]'),
      };

      var media = root.querySelector('.hs-fit__media');

      /* The card takes the ratio of the photo showing, so `contain` never has
         anything left over to fill. Sizes come in two ratios and the fixed box
         left a band on six of the eight. */
      function fitBox(photo) {
        if (!media || !photo) return;
        var img = photo.querySelector('img');
        if (!img) return;
        var apply = function () {
          if (!img.naturalWidth || !img.naturalHeight) return;
          media.style.setProperty('--hs-fit-ar', img.naturalWidth + ' / ' + img.naturalHeight);
        };
        if (img.complete) apply();
        else img.addEventListener('load', apply, { once: true });
      }

      function select(btn, focus) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-checked', String(on));
          b.tabIndex = on ? 0 : -1;
        });

        /* If that size has no photo, the one already there is left alone.
           Emptying the box would leave a gray gap and a layout jump from
           having no content. */
        var i = btn.getAttribute('data-hs-fit-size');
        var match = photos.filter(function (p) { return p.getAttribute('data-hs-fit-photo') === i; })[0];
        if (match) {
          photos.forEach(function (p) {
            if (p === match) p.setAttribute('data-active', '');
            else p.removeAttribute('data-active');
          });
        }

        if (match) fitBox(match);

        if (tag) tag.textContent = btn.getAttribute('data-model') || '';
        Object.keys(out).forEach(function (k) {
          if (out[k]) out[k].textContent = btn.getAttribute('data-' + k) || '—';
        });
        if (focus) btn.focus();
      }

      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b, false); });
        b.addEventListener('keydown', function (e) {
          var d = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
          if (e.key === 'Home') return e.preventDefault(), select(buttons[0], true);
          if (e.key === 'End') return e.preventDefault(), select(buttons[buttons.length - 1], true);
          if (!d) return;
          e.preventDefault();
          select(buttons[(i + d + buttons.length) % buttons.length], true);
        });
      });

      var start = buttons.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
      select(start || buttons[0], false);
    }

    /* The theme's size guide opens through a hidden checkbox, which no
       keyboard can reach. The buttons are labels, so a pointer works on its
       own; this only adds Enter and Space for anyone not using one. Bound
       once for the page, and it covers the GLP-1 button too. */
    function wireKeyboard() {
      if (document.documentElement.dataset.hsSizeGuideKeys) return;
      document.documentElement.dataset.hsSizeGuideKeys = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var t = e.target.closest ? e.target.closest('[data-hs-size-guide]') : null;
        if (!t) return;
        var box = document.getElementById('size-guide');
        if (!box) return;
        e.preventDefault();
        box.checked = !box.checked;
      });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-findfit"]').forEach(init);
      wireKeyboard();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-hero"] && !Shopify.designMode) return;
  try {
    
  /* Someone who asks for reduced motion should not land on a looping video
     right away. It gets paused and the poster stays, which is the same first
     frame, so the section does not change appearance or height.

     This is done in JS and not with `@media (prefers-reduced-motion)` because
     CSS cannot stop playback: hiding it would leave the video running
     underneath, burning battery and data for nothing. */
  (function () {
    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;

    function calm(scope) {
      (scope || document).querySelectorAll('[data-hs-hero-video]').forEach(function (v) {
        v.autoplay = false;
        v.removeAttribute('autoplay');
        v.pause();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { calm(); });
    } else {
      calm();
    }
    document.addEventListener('shopify:section:load', function (e) { calm(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-neotex"] && !Shopify.designMode) return;
  try {
    
  /* Neotex product switch. Changing option swaps the whole set: the central
     photo, the four benefits, and the button link. Everything is rendered
     server-side; only what is shown gets toggled. */
  (function () {
    function init(root) {
      if (root.dataset.hsNtxReady) return;
      root.dataset.hsNtxReady = '1';

      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ntx-opt]'));
      if (opts.length < 2) return;

      var shots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ntx-shot]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ntx-group]'));
      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ntx-cta]'));

      function show(list, attr, key) {
        list.forEach(function (el) {
          var mine = el.getAttribute(attr) === key;
          /* If there is only one photo (the other state's is missing), the one
             that exists is left as-is: better to repeat the image than leave
             the slot empty. */
          if (attr === 'data-hs-ntx-shot' && list.length < 2) return;
          el.hidden = !mine;
        });
      }

      function select(btn, focus) {
        var key = btn.getAttribute('data-hs-ntx-opt');
        opts.forEach(function (o) {
          var on = o === btn;
          o.setAttribute('aria-checked', String(on));
          o.tabIndex = on ? 0 : -1;
        });
        show(shots, 'data-hs-ntx-shot', key);
        show(items, 'data-hs-ntx-group', key);
        if (ctas.length) show(ctas, 'data-hs-ntx-cta', key);
        if (focus) btn.focus();
      }

      opts.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b, false); mark(); tabstops(); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          select(opts[(i + d + opts.length) % opts.length], true);
          mark();
          tabstops();
        });
      });

      /* Which card is being read: the one closest to the middle of the rail.
         The Figma (35:182) shows it at full strength with a 141 circle and its
         paragraph on, and its neighbours at half. Only below 1024 -- from there
         up the rail becomes `display: contents` and the four sit in the grid.

         Cards hidden by the option switch are skipped: they are display:none
         and their box would read as zero. */
      var rail = root.querySelector('.hs-ntx__rail');
      var desktop = window.matchMedia('(min-width: 1024px)');

      function mark() {
        if (!rail) return;
        if (desktop.matches) {
          items.forEach(function (el) { el.removeAttribute('data-hs-ntx-active'); });
          return;
        }
        var box = rail.getBoundingClientRect();
        var mid = box.left + box.width / 2;
        var best = null;
        var bestD = Infinity;
        items.forEach(function (el) {
          if (el.hidden || !el.offsetParent) return;
          var r = el.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestD) { bestD = d; best = el; }
        });
        items.forEach(function (el) {
          if (el === best) el.setAttribute('data-hs-ntx-active', '');
          else el.removeAttribute('data-hs-ntx-active');
        });
      }

      /* Tapping a neighbour brings it to the middle, so the carousel can be
         driven by taps and not only by dragging. Smooth unless the visitor
         asked for less motion. */
      function centre(el) {
        if (!rail || !el || desktop.matches) return;
        var box = rail.getBoundingClientRect();
        var r = el.getBoundingClientRect();
        var to = rail.scrollLeft + (r.left + r.width / 2) - (box.left + box.width / 2);
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (rail.scrollTo) rail.scrollTo({ left: to, behavior: still ? 'auto' : 'smooth' });
        else rail.scrollLeft = to;
      }

      items.forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (desktop.matches) return;
          /* Anything genuinely clickable inside the card keeps its own job. */
          if (e.target.closest && e.target.closest('a, button')) return;
          if (el.hasAttribute('data-hs-ntx-active')) return;
          centre(el);
        });
        el.addEventListener('keydown', function (e) {
          if (desktop.matches) return;
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          if (el.hasAttribute('data-hs-ntx-active')) return;
          e.preventDefault();
          centre(el);
        });
      });

      /* Only the cards waiting their turn take a tab stop: the centred one is
         plain content and would be a dead stop. */
      function tabstops() {
        items.forEach(function (el) {
          if (desktop.matches || el.hasAttribute('data-hs-ntx-active')) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '0');
        });
      }

      if (rail) {
        var queued = false;
        var onScroll = function () {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(function () { queued = false; mark(); tabstops(); });
        };
        rail.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        if (desktop.addEventListener) desktop.addEventListener('change', function () { mark(); tabstops(); });
        mark();
        tabstops();
      }
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-neotex"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-onefabric"] && !Shopify.designMode) return;
  try {
    
  /* Accordion for the three steps, only below 1024. Above that width the CSS
     already leaves all three open, so the click must do nothing: if it closed
     one, on desktop there would be a gap where the design has text.

     The state lives in `data-open` (read by CSS) and in `aria-expanded` (read
     by a screen reader); both are written together so they never drift
     apart. */
  (function () {
    function init(root) {
      if (root.dataset.hsOfReady) return;
      root.dataset.hsOfReady = '1';

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-hs-of-step]'));
      if (steps.length < 2) return;

      function open(target) {
        steps.forEach(function (s) {
          var on = s === target;
          if (on) { s.setAttribute('data-open', ''); } else { s.removeAttribute('data-open'); }
          var btn = s.querySelector('[data-hs-of-toggle]');
          if (btn) btn.setAttribute('aria-expanded', String(on));
        });
      }

      root.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 1024px)').matches) return;
        var btn = e.target.closest && e.target.closest('[data-hs-of-toggle]');
        if (!btn) return;
        open(btn.closest('[data-hs-of-step]'));
      });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-onefabric"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-press"] && !Shopify.designMode) return;
  try {
    
  /* Press track arrows. Only needed below 1024: above that the CSS spreads
     the five logos out and hides the buttons.

     `scrollBy` and not `scrollIntoView`: the latter also moves the page's
     vertical scroll and causes a jump on click. */
  (function () {
    function init(root) {
      if (root.dataset.hsPressReady) return;
      root.dataset.hsPressReady = '1';

      var rail = root.querySelector('[data-hs-press-rail]');
      var prev = root.querySelector('[data-hs-press-prev]');
      var next = root.querySelector('[data-hs-press-next]');
      if (!rail || !prev || !next) return;

      /* Endless loop: the set of logos is cloned until it passes one full
         lap plus the visible width, and crossing either end jumps a whole
         set. The jump is not noticeable because at that position there is
         exactly the same content. Before, the track used to hit a wall and
         the arrows would turn off.

         Only matters below 1024: above that the CSS spreads the five logos
         out and hides the arrows. */
      /* ONLY below 1024. Above that the track does not scroll
         (`overflow: visible`, the five logos spread out), so cloning there
         did not loop: it stuffed 30 logos into a row that does not scroll,
         the track ended up at two different heights and the band went from
         194 to 312. */
      var narrow = window.matchMedia('(max-width: 1023px)');
      if (!narrow.matches) {
        narrow.addEventListener('change', function once(e) {
          if (!e.matches) return;
          narrow.removeEventListener('change', once);
          root.dataset.hsPressReady = '';
          init(root);
        });
        return;
      }

      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) return;

      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;

      function loopWidth() {
        var w = 0;
        items.forEach(function (c) { w += c.getBoundingClientRect().width + gap; });
        return w;
      }

      var guard = 0;
      while (rail.scrollWidth < loopWidth() * 2 + rail.clientWidth && guard < 20) {
        items.forEach(function (c) {
          var clone = c.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, [tabindex]').forEach(function (el) { el.tabIndex = -1; });
          rail.appendChild(clone);
        });
        guard++;
      }

      var loopW = loopWidth();

      /* It starts one lap in so that from the first logo you can also pull
         backward. */
      if (loopW > 0) rail.scrollLeft = loopW;

      function wrap() {
        if (loopW <= 0) return;
        if (rail.scrollLeft >= loopW * 2) rail.scrollLeft -= loopW;
        else if (rail.scrollLeft <= 0) rail.scrollLeft += loopW;
      }

      function step(dir) {
        rail.scrollBy({ left: dir * rail.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', wrap, { passive: true });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-press"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-products"] && !Shopify.designMode) return;
  try {
    
  /* Tabs, rail, and add to cart.

     About the cart: the theme's cart-drawer.js hooks up the forms with a
     querySelectorAll ONCE on load, with no delegation. Since this rail is
     rendered server-side, it works on the live store; but after a
     `shopify:section:load` (theme editor) those forms are no longer hooked
     up. That is why binding happens here ONLY in that case -- doing it on
     initial load too would add the product twice. */
  (function () {
    function initRails(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-pr-tab]'));
      var rails = Array.prototype.slice.call(root.querySelectorAll('[data-hs-pr-rail]'));
      if (!rails.length) return;

      var prev = root.querySelector('[data-hs-pr-prev]');
      var next = root.querySelector('[data-hs-pr-next]');
      var bar = root.querySelector('[data-hs-pr-progress]');

      function visible() {
        return rails.filter(function (r) { return !r.hidden; })[0] || rails[0];
      }

      /* A rail without overflow has nothing to scroll through: in that case
         both arrows stay disabled instead of pretending to do something. */
      function sync() {
        var rail = visible();
        var max = rail.scrollWidth - rail.clientWidth;
        var at = rail.scrollLeft;
        if (prev) prev.disabled = at <= 1;
        if (next) next.disabled = at >= max - 1;
        if (bar) bar.style.width = (max <= 0 ? 100 : Math.min(100, (at + rail.clientWidth) / rail.scrollWidth * 100)) + '%';
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-hs-pr-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
          rails.forEach(function (r) { r.hidden = r.getAttribute('data-hs-pr-rail') !== id; });
          visible().scrollLeft = 0;
          sync();
        });
        // Keyboard arrows over the pill group.
        tab.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = tabs[(i + d + tabs.length) % tabs.length];
          n.focus(); n.click();
        });
      });

      function step(dir) {
        var rail = visible();
        var card = rail.querySelector('.hs-pr__card');
        var by = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth;
        rail.scrollBy({ left: dir * by, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rails.forEach(function (r) { r.addEventListener('scroll', sync, { passive: true }); });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    /* Only for sections reloaded by the editor: replicates what
       cart-drawer.js does, since it no longer reaches them. */
    function bindForms(root) {
      root.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
        if (form.dataset.hsPrBound) return;
        form.dataset.hsPrBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[data-hs-pr-atc]');
          var id = form.querySelector('input[name="id"]');
          if (!id) return;
          if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = btn.dataset.labelBusy; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(id.value), quantity: 1 }),
          })
            .then(function (r) { return r.json(); })
            .then(function () { if (window.openCart) window.openCart(); })
            .catch(function (err) { console.error('Hot Shapers - add to cart:', err); })
            .finally(function () {
              if (!btn) return;
              btn.removeAttribute('aria-busy');
              btn.textContent = btn.dataset.labelDone;
              setTimeout(function () { btn.textContent = btn.dataset.labelIdle; }, 1600);
            });
        });
      });
    }

    function init(root, rebindForms) {
      if (root.dataset.hsPrReady) return;
      root.dataset.hsPrReady = '1';
      root.querySelectorAll('[data-hs-pr-atc]').forEach(function (b) {
        b.dataset.labelIdle = b.textContent.trim();
      });
      initRails(root);
      if (rebindForms) bindForms(root);
    }

    function scan(scope, rebindForms) {
      (scope || document)
        .querySelectorAll('[data-section-type="hs-home-products"]')
        .forEach(function (el) { init(el, rebindForms); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(null, false); });
    } else {
      scan(null, false);
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target, true); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-stats"] && !Shopify.designMode) return;
  try {
    
  /* Playback control for the study video.

     Three things that are not obvious:
     - the button's state is not set by the click, it is set by the video's
       `play` and `pause` events -- so the icon stays correct even if the
       browser stops it;
     - someone who asks for reduced motion does not land on a loop: the
       poster stays and the button is there to start it by hand;
     - off-screen it pauses on its own, but on return it only restarts if the
       person did not pause it themselves. A video that comes back to life
       after you turned it off is one of the most annoying things. */
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsStVideoReady) return;
      var video = root.querySelector('[data-hs-st-video]');
      var btn = root.querySelector('[data-hs-st-toggle]');
      if (!video || !btn) return;
      root.dataset.hsStVideoReady = '1';

      var playLabel = btn.getAttribute('data-play-label') || 'Play video';
      var pauseLabel = btn.getAttribute('data-pause-label') || 'Pause video';
      var userPaused = false;

      function sync() {
        var playing = !video.paused && !video.ended;
        if (playing) {
          btn.setAttribute('data-playing', '');
        } else {
          btn.removeAttribute('data-playing');
        }
        btn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
      }

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);

      btn.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          var r = video.play();
          if (r && r.catch) r.catch(function () {});
        } else {
          userPaused = true;
          video.pause();
        }
      });

      if (REDUCE) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        userPaused = true;
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!userPaused && !REDUCE) {
                var r = video.play();
                if (r && r.catch) r.catch(function () {});
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.2 }).observe(video);
      }

      sync();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-stats"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-home-ugc"] && !Shopify.designMode) return;
  try {
    
  /* Two things: marking the center card to enlarge it, and the sound
     button. Videos start muted because every browser blocks an autoplay
     with audio, and besides, nobody wants a homepage talking at them. */
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsUgcReady) return;
      root.dataset.hsUgcReady = '1';

      var rail = root.querySelector('[data-hs-ugc-rail]');
      if (!rail) return;

      /* Sound delegated at the root: covers the original cards and their clones. */
      root.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-hs-ugc-mute]');
        if (!btn) return;
        var card = btn.closest('.hs-ugc__card');
        var video = card && card.querySelector('video');
        if (!video) return;
        var turningOn = video.muted;

        /* Only one can play sound. Before, unmuting a second video played
           both at once and there was no way to know which one to mute. */
        root.querySelectorAll('.hs-ugc__card video').forEach(function (v) { v.muted = true; });
        root.querySelectorAll('[data-hs-ugc-mute]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });

        video.muted = !turningOn;
        btn.setAttribute('aria-pressed', String(turningOn));
      });

      var originals = Array.prototype.slice.call(rail.children);
      if (originals.length < 2) return;

      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;

      /* Width of one full set (includes the gap separating it from the
         clone): it is the exact distance of the invisible jump when the
         loop restarts. */
      var loopW = 0;
      originals.forEach(function (c) { loopW += c.getBoundingClientRect().width + gap; });
      if (loopW <= 0) return;

      /* Clone the set until there is a full extra set beyond what is
         visible, so that when the scroll resets the gap is already filled.
         The clones are decorative. */
      var target = loopW + rail.clientWidth + 50;
      var guard = 0;
      while (rail.scrollWidth < target && guard < 20) {
        originals.forEach(function (c) {
          var clone = c.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('button, a, [tabindex]').forEach(function (el) { el.tabIndex = -1; });
          clone.querySelectorAll('video').forEach(function (v) {
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          });
          rail.appendChild(clone);
        });
        guard++;
      }

      var paused = false;
      var resumeTimer = null;
      function hardPause() { paused = true; }
      function resume() { paused = false; }
      function softPause() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 1400);
      }

      /* Arrows. They are wired up BEFORE the `prefers-reduced-motion` cutoff:
         with no automatic movement is exactly when they are needed most.

         One step = one card plus its gap, measured live (261+20 on desktop)
         and not hardcoded, so it keeps matching if the width changes.

         Going backwards from the start would hit the edge: the rail is a
         loop with clones behind it, so first it jumps a whole set forward
         with no animation and only then eases backward smoothly. The jump
         is invisible because the content at that position is identical. */
      function step(dir) {
        var first = rail.querySelector('.hs-ugc__card');
        var d = (first ? first.getBoundingClientRect().width : 261) + gap;
        softPause();
        if (dir < 0 && rail.scrollLeft < d) rail.scrollLeft += loopW;
        rail.scrollBy({ left: dir * d, behavior: 'smooth' });
      }

      var prev = root.querySelector('[data-hs-ugc-prev]');
      var next = root.querySelector('[data-hs-ugc-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      if (REDUCE) return;

      /* Pauses on hover or focus (to watch a reel), and yields while the
         user is dragging or scrolling. */
      rail.addEventListener('pointerenter', hardPause);
      rail.addEventListener('pointerleave', resume);
      rail.addEventListener('focusin', hardPause);
      rail.addEventListener('focusout', resume);
      rail.addEventListener('pointerdown', softPause);
      rail.addEventListener('wheel', softPause, { passive: true });
      rail.addEventListener('touchstart', softPause, { passive: true });

      var SPEED = 0.5; /* px per frame (~30px/s at 60Hz) */
      function tick() {
        if (!paused) {
          rail.scrollLeft += SPEED;
          if (rail.scrollLeft >= loopW) rail.scrollLeft -= loopW;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-home-ugc"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pdp-beforeafter"] && !Shopify.designMode) return;
  try {
    
  /* The size filter does not hide cases: it reduces the list the arrows
     advance over, so the counter says "1 of 7" when filtering by a band. A
     chip with no cases arrives disabled straight from Liquid. */
  (function () {
    function init(root) {
      if (root.dataset.hsBaReady) return;
      root.dataset.hsBaReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-slide]'));
      if (!slides.length) return;

      var shots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-shot]'));
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-filter]'));
      var count = root.querySelector('[data-hs-ba-count]');
      /* There are two sets of arrows -- the panel's and the photo row's --
         and only one shows at a time. Both are wired up: which one is
         visible is decided by the CSS, not the JS. */
      var prev = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-prev]'));
      var next = Array.prototype.slice.call(root.querySelectorAll('[data-hs-ba-next]'));
      var ofWord = root.getAttribute('data-of') || 'of';

      var media = root.querySelector('.hs-ba__media');
      var progress = root.querySelector('[data-hs-ba-progress]');
      var wide = window.matchMedia('(min-width: 1024px)');

      /* Two modes with the same list: on desktop one photo shows and the
         arrows lead; on phone every filtered one sits on a track and
         whichever ends up centered while dragging leads. */
      function isRail() { return !wide.matches; }

      var pool = slides.slice();
      var i = 0;
      var syncing = false;

      function idOf(slide) { return slide.getAttribute('data-hs-ba-slide'); }
      function shotOf(slide) {
        var id = idOf(slide);
        for (var k = 0; k < shots.length; k++) {
          if (shots[k].getAttribute('data-hs-ba-shot') === id) return shots[k];
        }
        return null;
      }

      function paint(recenter) {
        var current = pool[i];
        if (!current) return;
        slides.forEach(function (s) { s.hidden = s !== current; });

        if (isRail()) {
          /* On the track every filtered one shows, not just the current
             one. */
          shots.forEach(function (n) { n.hidden = true; });
          pool.forEach(function (s) {
            var sh = shotOf(s);
            if (sh) sh.hidden = false;
          });
          if (recenter && media) {
            var target = shotOf(current);
            if (target) {
              syncing = true;
              media.scrollLeft = target.offsetLeft - media.offsetLeft;
              /* Smooth scrolling fires events; they are ignored until it
                 settles. */
              setTimeout(function () { syncing = false; }, 120);
            }
          }
        } else {
          var id = idOf(current);
          shots.forEach(function (n) { n.hidden = n.getAttribute('data-hs-ba-shot') !== id; });
        }

        if (count) count.textContent = (i + 1) + ' ' + ofWord + ' ' + pool.length;

        /* The thumb takes up the fraction it's owed and travels across
           whatever is left of the track: on the first it sits flush left
           and on the last, flush right. Width and position are percentages
           of the same track, so there's no need to know how many pixels it
           measures. */
        if (progress) {
          var n = pool.length;
          var wPct = n ? Math.max(100 / n, 8) : 100;
          var ratio = n > 1 ? i / (n - 1) : 0;
          progress.style.width = wPct + '%';
          progress.style.left = ((100 - wPct) * ratio) + '%';
        }

        /* The ends are ends: it does not wrap around. The arrow that no
           longer leads anywhere gets disabled, which is what the
           stylesheet has been accounting for from the start with 35%
           opacity. */
        prev.forEach(function (btn) { btn.disabled = i <= 0; });
        next.forEach(function (btn) { btn.disabled = i >= pool.length - 1; });
      }

      /* While dragging, the text card follows whichever photo ends up most
         centered. */
      if (media) {
        media.addEventListener('scroll', function () {
          if (!isRail() || syncing) return;
          var mid = media.scrollLeft + media.clientWidth / 2;
          var best = 0;
          var bestD = Infinity;
          pool.forEach(function (s, k) {
            var sh = shotOf(s);
            if (!sh || sh.hidden) return;
            var c = sh.offsetLeft - media.offsetLeft + sh.offsetWidth / 2;
            var dd = Math.abs(c - mid);
            if (dd < bestD) { bestD = dd; best = k; }
          });
          if (best !== i) { i = best; paint(false); }
        }, { passive: true });
      }

      wide.addEventListener('change', function () { paint(true); });

      function filter(band) {
        var picked = band ? slides.filter(function (s) { return s.getAttribute('data-band') === band; }) : slides.slice();
        if (!picked.length) return;
        pool = picked;
        i = 0;
        paint(true);
      }

      filters.forEach(function (btn, k) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          filters.forEach(function (o) { o.setAttribute('aria-pressed', String(o === btn)); });
          filter(btn.getAttribute('data-hs-ba-filter'));
        });
        btn.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          filters[(k + d + filters.length) % filters.length].focus();
        });
      });

      function step(d) {
        return function () {
          var to = i + d;
          if (to < 0 || to > pool.length - 1) return;
          i = to;
          paint(true);
        };
      }
      prev.forEach(function (btn) { btn.addEventListener('click', step(-1)); });
      next.forEach(function (btn) { btn.addEventListener('click', step(1)); });
      paint(true);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-pdp-beforeafter"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pdp-neotex"] && !Shopify.designMode) return;
  try {
    
  /* Playback control for the study video.

     Three things that are not obvious:
     - the button's state is not set by the click, it is set by the video's
       `play` and `pause` events -- so the icon stays correct even if the
       browser stops it;
     - someone who asks for reduced motion does not land on a loop: the
       poster stays and the button is there to start it by hand;
     - off-screen it pauses on its own, but on return it only restarts if the
       person did not pause it themselves. A video that comes back to life
       after you turned it off is one of the most annoying things. */
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsStVideoReady) return;
      var video = root.querySelector('[data-hs-st-video]');
      var btn = root.querySelector('[data-hs-st-toggle]');
      if (!video || !btn) return;
      root.dataset.hsStVideoReady = '1';

      var playLabel = btn.getAttribute('data-play-label') || 'Play video';
      var pauseLabel = btn.getAttribute('data-pause-label') || 'Pause video';
      var userPaused = false;

      function sync() {
        var playing = !video.paused && !video.ended;
        if (playing) {
          btn.setAttribute('data-playing', '');
        } else {
          btn.removeAttribute('data-playing');
        }
        btn.setAttribute('aria-label', playing ? pauseLabel : playLabel);
      }

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);

      btn.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          var r = video.play();
          if (r && r.catch) r.catch(function () {});
        } else {
          userPaused = true;
          video.pause();
        }
      });

      if (REDUCE) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        userPaused = true;
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!userPaused && !REDUCE) {
                var r = video.play();
                if (r && r.catch) r.catch(function () {});
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.2 }).observe(video);
      }

      sync();
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-pdp-neotex"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pdp-products"] && !Shopify.designMode) return;
  try {
    
  /* Tabs, rail, and add to cart.

     About the cart: the theme's cart-drawer.js hooks up the forms with a
     querySelectorAll ONCE on load, with no delegation. Since this rail is
     rendered server-side, it works on the live store; but after a
     `shopify:section:load` (theme editor) those forms are no longer hooked
     up. That is why binding happens here ONLY in that case -- doing it on
     initial load too would add the product twice. */
  (function () {
    function initRails(root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hs-pr-tab]'));
      var rails = Array.prototype.slice.call(root.querySelectorAll('[data-hs-pr-rail]'));
      if (!rails.length) return;

      var prev = root.querySelector('[data-hs-pr-prev]');
      var next = root.querySelector('[data-hs-pr-next]');
      var bar = root.querySelector('[data-hs-pr-progress]');

      function visible() {
        return rails.filter(function (r) { return !r.hidden; })[0] || rails[0];
      }

      /* A rail without overflow has nothing to scroll through: in that case
         both arrows stay disabled instead of pretending to do something. */
      function sync() {
        var rail = visible();
        var max = rail.scrollWidth - rail.clientWidth;
        var at = rail.scrollLeft;
        if (prev) prev.disabled = at <= 1;
        if (next) next.disabled = at >= max - 1;
        if (bar) bar.style.width = (max <= 0 ? 100 : Math.min(100, (at + rail.clientWidth) / rail.scrollWidth * 100)) + '%';
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-hs-pr-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t === tab)); });
          rails.forEach(function (r) { r.hidden = r.getAttribute('data-hs-pr-rail') !== id; });
          visible().scrollLeft = 0;
          sync();
        });
        // Keyboard arrows over the pill group.
        tab.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = tabs[(i + d + tabs.length) % tabs.length];
          n.focus(); n.click();
        });
      });

      function step(dir) {
        var rail = visible();
        var card = rail.querySelector('.hs-pr__card');
        var by = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth;
        rail.scrollBy({ left: dir * by, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rails.forEach(function (r) { r.addEventListener('scroll', sync, { passive: true }); });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    /* Only for sections reloaded by the editor: replicates what
       cart-drawer.js does, since it no longer reaches them. */
    function bindForms(root) {
      root.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
        if (form.dataset.hsPrBound) return;
        form.dataset.hsPrBound = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('[data-hs-pr-atc]');
          var id = form.querySelector('input[name="id"]');
          if (!id) return;
          if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = btn.dataset.labelBusy; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(id.value), quantity: 1 }),
          })
            .then(function (r) { return r.json(); })
            .then(function () { if (window.openCart) window.openCart(); })
            .catch(function (err) { console.error('Hot Shapers - add to cart:', err); })
            .finally(function () {
              if (!btn) return;
              btn.removeAttribute('aria-busy');
              btn.textContent = btn.dataset.labelDone;
              setTimeout(function () { btn.textContent = btn.dataset.labelIdle; }, 1600);
            });
        });
      });
    }

    function init(root, rebindForms) {
      if (root.dataset.hsPrReady) return;
      root.dataset.hsPrReady = '1';
      root.querySelectorAll('[data-hs-pr-atc]').forEach(function (b) {
        b.dataset.labelIdle = b.textContent.trim();
      });
      initRails(root);
      if (rebindForms) bindForms(root);
    }

    function scan(scope, rebindForms) {
      (scope || document)
        .querySelectorAll('[data-section-type="hs-pdp-products"]')
        .forEach(function (el) { init(el, rebindForms); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(null, false); });
    } else {
      scan(null, false);
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target, true); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  /* Two things: marking the center card to enlarge it, and the sound
     button. Videos start muted because every browser blocks an autoplay
     with audio, and besides, nobody wants a homepage talking at them. */
  (function () {
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsUgcReady) return;
      root.dataset.hsUgcReady = '1';

      var rail = root.querySelector('[data-hs-ugc-rail]');
      if (!rail) return;

      /* Sound delegated at the root: covers the original cards and their clones. */
      root.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-hs-ugc-mute]');
        if (!btn) return;
        var card = btn.closest('.hs-ugc__card');
        var video = card && card.querySelector('video');
        if (!video) return;
        var turningOn = video.muted;

        /* Only one can play sound. Before, unmuting a second video played
           both at once and there was no way to know which one to mute. */
        root.querySelectorAll('.hs-ugc__card video').forEach(function (v) { v.muted = true; });
        root.querySelectorAll('[data-hs-ugc-mute]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });

        video.muted = !turningOn;
        btn.setAttribute('aria-pressed', String(turningOn));
      });

      var originals = Array.prototype.slice.call(rail.children);
      if (originals.length < 2) return;

      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;

      /* Ancho de un set entero, con el gap que lo separa del siguiente: es
         la distancia exacta del salto invisible cada vez que el ciclo se
         reinicia.

         `offsetWidth` y no `getBoundingClientRect().width`: el reel enfocado
         lleva un `scale(1.12)`, y el rect devuelve el ancho YA escalado. Con
         el rect, el ciclo salia ~31px mas largo de lo que mide la fila y el
         salto se veia. El offset ignora el transform, que es lo que hace
         falta aca. */
      var cardStep = originals[0].offsetWidth + gap;
      var loopW = originals.length * cardStep;
      if (loopW <= 0) return;

      /* Se clona DE A UNA TARJETA, no de a set entero. Clonando por sets se
         pasaba de largo: con 5 reels llenaba 15 videos en el DOM donde
         alcanzan 12, y son videos, no imagenes. Se clona hasta cubrir lo que
         se ve mas un ciclo completo mas un paso de holgura, que es el minimo
         para que el salto de `loopW` caiga siempre sobre contenido ya
         construido y por lo tanto no se note. */
      var target = loopW + rail.clientWidth + cardStep + 20;
      var guard = 0;
      var i = 0;
      while (rail.scrollWidth < target && guard < 60) {
        var clone = originals[i % originals.length].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('button, a, [tabindex]').forEach(function (el) { el.tabIndex = -1; });
        clone.querySelectorAll('video').forEach(function (v) {
          v.muted = true;
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
        });
        rail.appendChild(clone);
        i++;
        guard++;
      }

      if (root.dataset.drag === 'true') {
      /* Pastel #6: "make this section scrollable to allow people to focus on
         any of the videos". El rail siempre tuvo `overflow-x: auto`, pero en
         escritorio con mouse eso no alcanza: la barra va oculta
         (`scrollbar-width: none`) y sin flechas no queda ningun asidero.
         Arrastrar con el puntero es el que faltaba.

         El umbral de 4px es para no robarle el click al boton de sonido: por
         debajo de eso el gesto sigue siendo un click. */
      (function () {
        var down = false, moved = false, startX = 0, startLeft = 0;
        rail.style.cursor = 'grab';
        rail.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          down = true; moved = false;
          startX = e.clientX; startLeft = rail.scrollLeft;
          rail.style.cursor = 'grabbing';
        });
        rail.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) < 4) return;
          if (!moved) { moved = true; try { rail.setPointerCapture(e.pointerId); } catch (err) {} }
          rail.scrollLeft = startLeft - dx;
          e.preventDefault();
        });
        function end(e) {
          if (!down) return;
          down = false;
          rail.style.cursor = 'grab';
          if (moved) {
            /* Un click sintetico despues de arrastrar abriria el sonido del
               reel donde soltaste. Se cancela una sola vez. */
            rail.addEventListener('click', function stop(ev) {
              ev.stopPropagation(); ev.preventDefault();
              rail.removeEventListener('click', stop, true);
            }, true);
          }
          try { if (e && e.pointerId != null) rail.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        rail.addEventListener('pointerup', end);
        rail.addEventListener('pointercancel', end);
        rail.addEventListener('pointerleave', end);
        /* Nada de mapear la rueda vertical al desplazamiento horizontal: le
           robaba el scroll a la pagina al pasar por encima de la seccion, que
           es peor que el problema que resolvia. El arrastre alcanza, y la
           rueda horizontal del trackpad sigue funcionando sola. */
      })();
      }

      var paused = false;
      var resumeTimer = null;
      function hardPause() { paused = true; }
      function resume() { paused = false; }
      function softPause() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 1400);
      }

      /* Flechas. Se conectan ANTES del corte por `prefers-reduced-motion`:
         justo cuando no hay movimiento automatico es cuando mas hacen falta.

         Un paso es una tarjeta mas su gap, medido en vivo (261+20 en
         escritorio) y no fijo, para que siga valiendo si cambia el ancho.

         El desplazamiento no termina nunca, en ninguna de las dos
         direcciones. El truco es que el rail se mantiene siempre dentro del
         primer ciclo: antes de cada paso, si ya paso de `loopW` se le resta,
         y si esta por debajo de un paso yendo hacia atras se le suma. Como el
         contenido se repite cada `loopW`, ese reacomodo cae sobre una fila
         identica y no se ve. Es el mismo reinicio que usa el marquee, y por
         eso conviven sin pelearse. */
      function step(dir) {
        var first = rail.querySelector('.hs-ugc__card');
        var d = (first ? first.offsetWidth : 261) + gap;
        softPause();
        if (rail.scrollLeft >= loopW) rail.scrollLeft -= loopW;
        if (dir < 0 && rail.scrollLeft < d) rail.scrollLeft += loopW;
        rail.scrollBy({ left: dir * d, behavior: 'smooth' });
      }

      var prev = root.querySelector('[data-hs-ugc-prev]');
      var next = root.querySelector('[data-hs-ugc-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      /* El carrusel automatico es opcional: en el PDP el cliente lo pidio
         quieto (Pastel #16). Las flechas ya quedaron conectadas arriba, asi
         que el rail sigue siendo navegable sin el. */
      if (root.dataset.pop === 'true') {
        var popRaf = null;
        var popCards = function () {
          popRaf = null;
          /* Rects de viewport y no offsetLeft: offsetLeft se mide contra el
             offsetParent, que aca no es el rail, asi que comparado con el
             centro del rail elegia siempre una card de mas a la izquierda. */
          var railRect = rail.getBoundingClientRect();
          var mid = railRect.left + railRect.width / 2;
          var best = null, bestD = Infinity;
          rail.querySelectorAll('.hs-ugc__card').forEach(function (c) {
            var r = c.getBoundingClientRect();
            var d = Math.abs(r.left + r.width / 2 - mid);
            if (d < bestD) { bestD = d; best = c; }
          });
          rail.querySelectorAll('.hs-ugc__card').forEach(function (c) {
            if (c === best) c.setAttribute('data-hs-ugc-pop', '');
            else c.removeAttribute('data-hs-ugc-pop');
          });
        };
        var queuePop = function () { if (!popRaf) popRaf = requestAnimationFrame(popCards); };
        rail.addEventListener('scroll', queuePop, { passive: true });
        window.addEventListener('resize', queuePop);
        popCards();
      }

      if (REDUCE || root.dataset.autoscroll === 'false') return;

      /* Pauses on hover or focus (to watch a reel), and yields while the
         user is dragging or scrolling. */
      rail.addEventListener('pointerenter', hardPause);
      rail.addEventListener('pointerleave', resume);
      rail.addEventListener('focusin', hardPause);
      rail.addEventListener('focusout', resume);
      rail.addEventListener('pointerdown', softPause);
      rail.addEventListener('wheel', softPause, { passive: true });
      rail.addEventListener('touchstart', softPause, { passive: true });

      var SPEED = 0.5; /* px per frame (~30px/s at 60Hz) */
      function tick() {
        if (!paused) {
          rail.scrollLeft += SPEED;
          if (rail.scrollLeft >= loopW) rail.scrollLeft -= loopW;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-section-type="hs-pdp-ugc"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-it-works"] && !Shopify.designMode) return;
  try {
    
  const brandsInfoSlider = () => {
    new Swiper('.why-it-works .swiper-container', {
      spaceBetween: 10,
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
     },
     breakpoints: {
        768: {
          slidesPerView: "auto",
          spaceBetween: 10,
        }
      },
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    brandsInfoSlider();
  })

  } catch(e) { console.error(e); }
})();
})();
